import PaymentStatusBadge, {
  optionsForPaymentStatus,
} from './PaymentStatusBadge';
export { optionsForPaymentStatus };
export default PaymentStatusBadge;
